import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the BuyInsurancePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-buy-insurance',
  templateUrl: 'buy-insurance.html',
})
export class BuyInsurancePage {

  public insurance = this.navParams.data;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    console.log(this.navParams.data);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BuyInsurancePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/buy-insurance/buy-insurance.ts